/**
 * Utility functions for Right-to-Left (RTL) language support
 */

// Languages that require RTL direction
export const RTL_LANGUAGES = ["ar", "he", "fa", "ur"] as const;

export type RTLLanguage = (typeof RTL_LANGUAGES)[number];

/**
 * Determines if a language code requires RTL direction
 * @param languageCode - Language code (e.g., 'ar', 'en-US', 'ar-SA')
 * @returns boolean indicating if RTL is needed
 */
export const isRTLLanguage = (languageCode: string): boolean => {
  if (!languageCode) return false;

  // Extract base language code (remove region/country code)
  const baseLanguage = languageCode.split("-")[0].toLowerCase();

  return RTL_LANGUAGES.includes(baseLanguage as RTLLanguage);
};

/**
 * Gets the text direction for a given language
 * @param languageCode - Language code
 * @returns 'rtl' or 'ltr'
 */
export const getTextDirection = (languageCode: string): "rtl" | "ltr" => {
  return isRTLLanguage(languageCode) ? "rtl" : "ltr";
};
